import Box from '@mui/material/Box';

import RecipeTile from 'src/components/recipe/recipe-tile';

// ----------------------------------------------------------------------

type Recipe = {
  pimcoreRecipeId: number;
  [key: string]: unknown;
};

type Props = {
  recipes: Recipe[];
  sx?: object;
};

export default function RecipeList({ recipes, sx }: Props) {
  return (
    <Box
      gap={3}
      display="grid"
      gridTemplateColumns={{
        xs: 'repeat(1, 1fr)',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(3, 1fr)',
      }}
      sx={sx}
    >
      {recipes.map((recipe) => (
        <RecipeTile
          key={String(recipe.pimcoreRecipeId)}
          recipe={recipe}
        />
      ))}
    </Box>
  );
}
